export const emailRegexp = /[a-z0-9-]+@[a-z0-9-]+\.[a-z]{2,20}$/;
export const numbersRegexp = /[0-9]$/;
export const russianPhoneRegexp =
	/^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
export const phoneExtraSymbolsRegexp = /[^+0-9]/gm;
export const nameRegexp = /[a-zA-Zа-яА-я]$/;
export const urlRegexp =
	/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
export const textWithoutHtmlTagsRegexp = /(<([^>]+)>)/gi;
